import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Loader from "../../common/loader";
import { capitalizeFirstLetter, formateDate } from "../../../../utils/commonfunction";
import { useTranslation } from "react-i18next";
// import $ from "jquery";
import Breadcrums from "../../common/breadcrumbs";
import { ROLE } from "../../../../utils/Constants";
// import { detail } from "../../../doctor/services/patient.services";
import { Details } from "../../services/customer.services"

const ViewCustomer = (props) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const params = useParams();
  const [showdefault, setShowDefault] = useState({});

  const breadcrumbs = [
    { title: t("admin.cafes.link_dashboard"), url: "/admin/dashboard/1" },
    {
      title: 'Customer Management',
      url: "/admin/customer-management/customer/list/1",
    },
    { title: t("admin.cafes.link_view"), url: "" },
  ];

  useEffect(() => {
     Details(params.id)
      .then((response) => {
        setShowDefault(response && response.data ? response.data : []);
      })
      .catch((error) => {
        console.log("error=====>", error);
      });
  }, [params.id]);

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      <div className="row row-sm">
        <div className="col-lg-12 col-md-12 animation_fade">
          <div className="card custom-card">
            <div className="card-body">
              {showdefault && Object.keys(showdefault).length > 0 ? <div className='row'>
                <div className="col-lg-12 form-group">
                  <table id="simple-table" className="table  table-bordered table-hover">
                    <tbody>
                      <tr>
                        <th> {t("Customer ID")}</th>
                        <td className="text-capitalize">
                          {showdefault && showdefault.customer_register_id
                            ? '#' + (showdefault.customer_register_id)
                            : "N/A"}
                        </td>
                      </tr>
                      <tr>
                        <th>{t("Customer Name")}</th>
                        <td className="text-capitalize">
                          {showdefault && showdefault.name ? showdefault.name : "N/A"}
                        </td>
                      </tr>

                      <tr>
                        <th>{t("Email")}</th>
                        <td>
                          {showdefault && showdefault.email
                            ? showdefault.email
                            : "N/A"}
                        </td>
                      </tr>
                      <tr>
                        <th>{t("Contact Number")}</th>
                        <td>
                          {showdefault && showdefault.phone_number
                            ? capitalizeFirstLetter(showdefault.phone_number)
                            : "N/A"}
                        </td>
                      </tr>
                      <tr>
                        <th>{t("DOB")}</th>
                        <td>
                          {showdefault && showdefault?.dob
                            ? formateDate(showdefault.dob)
                            : "N/A"}
                        </td>
                      </tr>
                      <tr>
                        <th>{t("Gender")}</th>
                        <td>
                          {showdefault && showdefault.gender
                            ? capitalizeFirstLetter(showdefault.gender)
                            : "N/A"}
                        </td>
                      </tr>
                      <tr>
                        <th>{t("Language Preference")}</th>
                        <td>
                          {showdefault && showdefault.language_preference
                            ? capitalizeFirstLetter(showdefault.language_preference)
                            : "N/A"}
                        </td>
                      </tr>
                       <tr>
                        <th>{t("Wellness Centre ID")}</th>
                        <td>
                          {showdefault && showdefault.centers && showdefault.centers.length > 0
                            ? '#' + showdefault.centers?.map((center) => center.center_register_id).join(", ")
                            : "N/A"}
                        </td>
                      </tr>
                       <tr>
                        <th>{t("Wellness Centre Name")}</th>
                        <td>
                          {showdefault && showdefault.centers.length > 0
                            ? showdefault.centers?.map((center) => capitalizeFirstLetter(center.center_name)).join(", ")
                            : "N/A"}
                        </td>
                      </tr>
                      {
                        showdefault?.wellness_club_id
                        ?
                        <tr>
                          <th>Wellness Club Id</th>
                          <td>
                            {showdefault.wellness_club_id}
                          </td>
                        </tr>
                        : null
                      }
                    </tbody>
                  </table>
                  <div className="mt-5">
                    <button className="btn ripple btn-dark" type='button' onClick={() => navigate(-1)}>
                      <i className="ace-icon-solid ion-arrow-return-left bigger-110 mx-1"></i>
                      {t("admin.button.btn_back")}
                    </button>
                  </div>
                </div>
              </div> : <Loader />}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewCustomer;
